import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';



@Pipe({ name: 'htmlDecode', standalone: true })
export class HtmlDecodePipe implements PipeTransform {
  transform(value: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = value;
    return txt.value;
  }


  // Moved displayRenderedFields logic here as a utility-like method
  static displayRenderedFields(aoFields: any[]): any[] {
    const renderedFields: any[] = [];
    const appScope = (window as any).appScope;

    if (!appScope?.jobFieldsToDisplay || !aoFields) return renderedFields;

    const getField = (name: string) =>
      aoFields.find(field => field.QuestionName?.toLowerCase() === name?.toLowerCase());

    if (
      (!appScope.bresponsiveCandidateZone || !appScope.bCandidateZone || appScope.bSimiliarJobs) &&
      appScope.jobFieldsToDisplay.Position1
    ) {
      const field = getField(appScope.jobFieldsToDisplay.Position1);
      if (field) {
        field.ClassName = 'position1';
        renderedFields.push(field);
      }
    }

    if (appScope.jobFieldsToDisplay.JobTitle) {
      const field = getField(appScope.jobFieldsToDisplay.JobTitle);
      if (field) {
        field.ClassName = 'jobtitle';
        renderedFields.push(field);
      }
    }

    if (Array.isArray(appScope.jobFieldsToDisplay.Position3)) {
      appScope.jobFieldsToDisplay.Position3.forEach((qName: string) => {
        const field = getField(qName);
        if (field) {
          field.ClassName = 'position3';
          renderedFields.push(field);
        }
      });
    }

    if (appScope.jobFieldsToDisplay.Summary) {
      const field = getField(appScope.jobFieldsToDisplay.Summary);
      if (field) {
        field.ClassName = 'jobdescription';
        renderedFields.push(field);
      }
    }

    const lastUpdatedField = aoFields.find(f => f.QuestionName?.toLowerCase() === 'lastupdated');
    if (
      lastUpdatedField?.Value?.includes('T') &&
      appScope.jobFieldsToDisplay.Position1?.toLowerCase() === 'lastupdated'
    ) {
      const [year, month, day] = lastUpdatedField.Value.split('T')[0].split('-');
      lastUpdatedField.Value = `${month}/${+day}/${+year}`;
    }

    return renderedFields;
  }
}
@Pipe({ name: 'stripHtml', standalone: true })
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    // Remove HTML tags using regex
    return value.replace(/<[^>]+>/g, '');
  }
}
@Pipe({
  name: 'safeEmbedHtml'
})
export class SafeEmbedHtmlPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string): SafeHtml {
    if (!html) return '';

    let transformed = html;

    // Replace YouTube full links with iframe
    const youtubeFull = /https?:\/\/(?:www\.)?youtube\.com\/watch\?v=([^\s&]+)/g;
    transformed = transformed.replace(youtubeFull, (match, id) => {
      return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${id}" frameborder="0" allowfullscreen></iframe>`;
    });

    // Replace YouTube short links
    const youtubeShort = /https?:\/\/youtu\.be\/([^\s&]+)/g;
    transformed = transformed.replace(youtubeShort, (match, id) => {
      return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${id}" frameborder="0" allowfullscreen></iframe>`;
    });
    return this.sanitizer.bypassSecurityTrustHtml(transformed);
  }
}
